import AbstractComponent from "./abstract-component";

export default class ContactForm extends AbstractComponent {
    constructor(el) {
        super(el);
        this.DOM = {};
        this.initDomElements();
        this.initEvents();
        this.checkInitialValues();
    }

    initDomElements() {
        this.DOM.form = this.$el.querySelector('form');
        if (!this.DOM.form) return;
        
        this.DOM.inputs = this.DOM.form.querySelectorAll('input[type="text"], input[type="email"],input[type="tel"], textarea');
        this.DOM.selects = this.DOM.form.querySelectorAll('select');
        this.DOM.customButton = this.$el.querySelector('.c-button');
        this.DOM.submitButton = this.DOM.form.querySelector('input[type="submit"]');
        this.DOM.wpcf7 = this.$el.querySelector('.wpcf7');
        this.DOM.responseOutput = this.$el.querySelector('.wpcf7-response-output');
        this.DOM.formRows = this.DOM.form.querySelectorAll('.form-row');
    }

    initEvents() {
        if (!this.DOM.form) return;

        // Gérer les inputs et textareas
        this.DOM.inputs.forEach(input => {
            input.addEventListener('focus', () => this.handleFocus(input));
            input.addEventListener('blur', () => this.handleBlur(input));
            input.addEventListener('input', () => this.handleInput(input));
        });

        // Gérer les selects
        this.DOM.selects.forEach(select => {
            select.addEventListener('focus', () => this.handleFocus(select));
            select.addEventListener('blur', () => this.handleBlur(select));
            select.addEventListener('change', () => this.handleChange(select));
        });

        // Connecter le bouton personnalisé au formulaire
        if (this.DOM.customButton && this.DOM.form) {
            // Cacher le bouton submit de CF7 s'il existe
            if (this.DOM.submitButton) {
                this.DOM.submitButton.style.display = 'none';
            }
            
            // Connecter le bouton personnalisé
            this.DOM.customButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                // Valider le formulaire avant de le soumettre
                if (this.DOM.form.checkValidity()) {
                    // Utiliser requestSubmit si disponible (meilleure validation HTML5)
                    if (this.DOM.form.requestSubmit) {
                        this.DOM.form.requestSubmit();
                    } else if (this.DOM.submitButton) {
                        // Fallback : cliquer sur le bouton submit si disponible
                        this.DOM.submitButton.click();
                    } else {
                        // Dernier recours : soumettre directement
                        this.DOM.form.submit();
                    }
                } else {
                    // Si le formulaire n'est pas valide, déclencher la validation native
                    this.DOM.form.reportValidity();
                }
            });
        }

        // Écouter l'événement de succès de CF7
        if (this.DOM.wpcf7) {
            this.DOM.wpcf7.addEventListener('wpcf7mailsent', (e) => {
                this.handleFormSuccess();
            });
        }
    }

    handleFormSuccess() {
        // Cacher le bouton personnalisé
        if (this.DOM.customButton) {
            this.DOM.customButton.style.display = 'none';
        }
        
        // Appliquer pointer-events: none et cursor: not-allowed à tout le formulaire
        if (this.DOM.form) {
            this.DOM.form.style.pointerEvents = 'none';
            this.DOM.form.style.cursor = 'not-allowed';
        }
        
        // Trouver la form-row qui contient la réponse
        let responseRow = null;
        if (this.DOM.responseOutput) {
            // Remonter jusqu'à trouver la form-row parente
            let parent = this.DOM.responseOutput.parentElement;
            while (parent && parent !== this.DOM.form) {
                if (parent.classList && parent.classList.contains('form-row')) {
                    responseRow = parent;
                    break;
                }
                parent = parent.parentElement;
            }
        }
        
        // Réduire l'opacité de toutes les form-row sauf celle qui contient la réponse
        this.DOM.formRows.forEach(row => {
            if (row !== responseRow) {
                row.style.opacity = '0.75';
            }
        });
        
        // S'assurer que le message de réponse est visible
        if (this.DOM.responseOutput) {
            this.DOM.responseOutput.style.display = 'block';
        }
    }

    handleFocus(field) {
        const container = this.getContainer(field);
        if (container) {
            container.classList.add('focus');
        }
    }

    handleBlur(field) {
        const container = this.getContainer(field);
        if (container) {
            // Retirer la classe focus seulement si le champ est vide
            if (this.isEmpty(field)) {
                container.classList.remove('focus');
            }
        }
    }

    handleInput(field) {
        const container = this.getContainer(field);
        if (container) {
            if (this.isEmpty(field)) {
                container.classList.remove('focus');
            } else {
                container.classList.add('focus');
            }
        }
    }

    handleChange(select) {
        const container = this.getContainer(select);
        if (container) {
            if (this.isEmpty(select)) {
                container.classList.remove('focus');
            } else {
                container.classList.add('focus');
            }
        }
    }

    checkInitialValues() {
        // Vérifier les valeurs initiales au chargement
        this.DOM.inputs.forEach(input => {
            if (!this.isEmpty(input)) {
                const container = this.getContainer(input);
                if (container) {
                    container.classList.add('focus');
                }
            }
        });

        this.DOM.selects.forEach(select => {
            if (!this.isEmpty(select)) {
                const container = this.getContainer(select);
                if (container) {
                    container.classList.add('focus');
                }
            }
        });
    }

    getContainer(field) {
        // Trouver le conteneur parent .half ou .full
        // Utiliser closest() pour une recherche plus fiable dans toute la hiérarchie
        const container = field.closest('.half, .full');
        return container;
    }

    isEmpty(field) {
        if (field.tagName === 'SELECT') {
            return !field.value || field.value === '';
        }
        return !field.value || field.value.trim() === '';
    }

    destroy() {
        // Nettoyage si nécessaire
    }
}

